export default __webpack_public_path__ + "static/media/sarp_roto_404.c448f30f.jpg";